import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/your-play/access-controls')({
  beforeLoad: async ({ search, matches }) => {
    // only on exact match on this route, not the child
    if (matches.at(-1)?.id === Route.id) {
      throw redirect({ to: '/your-play/access-controls/all', search })
    }
  },
})
